import React, { useState } from 'react'
import '../../Fonts/Foco-Bold.ttf'
import styles from './CouponCard.module.css'
import RulesModal from './../RulesModal/RulesModal.js'
import Button from './../Button/Button.js'

const ActiveEnum = {
  ATIVO: 'ATIVO',
  ATIVAR: 'ATIVAR'
}

const CouponCard = (coupon) => {
  const contentModal = {
    description: coupon.description,
    rules: coupon.rules,
    detailedDescription: coupon.detailedDescription,
    imageUrl: coupon.imageUrl
  }
  const formatCurrency = (value) => {
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }

  const verifyActive = (value) => {
    return (value) ? ActiveEnum.ATIVO : ActiveEnum.ATIVAR
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isActive, setisActive] = useState(verifyActive(coupon.active))
  const [showLoader, setShowLoader] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const callbackActiveCoupon = () => {
    if (isActive === ActiveEnum.ATIVAR) {
      setShowLoader(true)
      const cpfNumbers = coupon.cpf.value.replace(/[^0-9]/g, '')
      fetch(`${process.env.REACT_APP_API_URL}/v1/wallets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'app-token': process.env.REACT_APP_API_TOKEN
        },
        body: JSON.stringify({
          channel: 'LOJA',
          couponId: coupon.couponId,
          customerCpf: cpfNumbers,
          origin: 'QRCODE'
        })
      }).then((resp) => {
        if (resp.status === 200) {
          setisActive(ActiveEnum.ATIVO)
        }
        setShowLoader(false)
      })
    }
  }

  return (
    <article className={styles.article}>
      <div className={styles.containerCoupon}>
        <div className={styles.containerTop}>
          <div className={styles.tagHeader}>
            <img src={coupon.imageHeaderUrl} />
          </div>
          <img className={styles.couponImage} src={coupon.imageUrl} />
          <div className={styles.contentCoupon}>
            {(() => {
              switch (coupon.type) {
                case 'PERCENTAGE_DISCOUNT':
                  return <span className={styles.couponValue}>{coupon.discountPercentage}% OFF</span>
                case 'FREE_SHIPPING':
                  return <span className={styles.couponValue}>Frete Grátis</span>
                case 'EXCHANGE_VOUCHER':
                  return <span className={styles.couponValue}>{formatCurrency(coupon.bonusValue)}</span>
                case 'FIXED_PRICE':
                  return <span className={styles.couponValue}>Por {formatCurrency(coupon.price)}</span>
                case 'BONUS_VALUE':
                  return (
                    <span className={styles.couponValue}>
                      {coupon.bonusValue !== null ? formatCurrency(coupon.bonusValue) + ' OFF' : coupon.bonusPercentage + '% OFF'}
                    </span>
                  )
              }
            })()}

            <span className={styles.couponTitle}>{coupon.title}</span>

            <div className={styles.couponDescription}>
              <span className={styles.couponDescriptionContent}>{coupon.description}</span>
            </div>
            <button className={styles.buttonRules} onClick={handleOpenModal}>
              Ver Regras
            </button>
          </div>
        </div>
        <div className={styles.containerBottom}>
          <span className={styles.expirateDate}>{coupon.validated}</span>
          <Button
            text={isActive}
            onSubmit={callbackActiveCoupon}
            loading={showLoader}
            disabled={showLoader}
            classCss={styles.activationButton}
          />
        </div>
      </div>
      <RulesModal
        className={styles.RulesModal}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        content={contentModal}
      />
    </article>
  )
}
export default CouponCard
